import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteUserAssessmentAssignmentMutation, deleteUserAssessmentAssignmentMutationVariables } from '../generated/deleteUserAssessmentAssignmentMutation';
import { userAssessmentAssignmentFieldsFragment } from '../models/UserAssessmentAssignment';

/**
 * Get a callback to delete a UserAssessmentAssignment in the store.
 */
export function useDeleteUserAssessmentAssignmentCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteUserAssessmentAssignmentMutation, deleteUserAssessmentAssignmentMutationVariables>(
        gql`
            mutation deleteUserAssessmentAssignmentMutation ($id: ID!) {
                deleteUserAssessmentAssignment(id: $id) {
                    ...userAssessmentAssignmentFields
                }
            }

            ${userAssessmentAssignmentFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
